import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import ReportForm from "./pages/ReportForm";
import SuccessPage from "./pages/SuccessPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import CaseDetail from "./pages/CaseDetail";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Notfall from "./pages/Notfall";
import FAQ from "./pages/FAQ";
import UeberUns from "./pages/UeberUns";
import WasPassiert from "./pages/WasPassiert";
import Selbstschutz from "./pages/Selbstschutz";
import Erfahrungen from "./pages/Erfahrungen";
import Eltern from "./pages/Eltern";
import Lehrer from "./pages/Lehrer";
import MobbingDokumentieren from "./pages/MobbingDokumentieren";
import MobbingProtokoll from "./pages/MobbingProtokoll";
import Cybermobbing from "./pages/Cybermobbing";
import Blog from "./pages/Blog";
import Betriebsrat from "./pages/Betriebsrat";
import Anwalt from "./pages/Anwalt";
import MobbingBeweise from "./pages/MobbingBeweise";
import BlogArtikelArbeitsplatz from "./pages/BlogArtikelArbeitsplatz";
import BlogArtikelProtokoll from "./pages/BlogArtikelProtokoll";
import CookieBanner from "./components/CookieBanner";
import { useState, useEffect, createContext } from "react";

// Auth Context
export const AuthContext = createContext(null);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("adminToken");
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  const [token, setToken] = useState(localStorage.getItem("adminToken"));

  useEffect(() => {
    const handleStorageChange = () => {
      setToken(localStorage.getItem("adminToken"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const login = (newToken) => {
    localStorage.setItem("adminToken", newToken);
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem("adminToken");
    setToken(null);
  };

  return (
    <HelmetProvider>
    <AuthContext.Provider value={{ token, login, logout }}>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-[#FFFDF9]">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/melden" element={<ReportForm />} />
            <Route path="/erfolg" element={<SuccessPage />} />
            
            {/* Info Pages */}
            <Route path="/faq" element={<FAQ />} />
            <Route path="/notfall" element={<Notfall />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/was-passiert" element={<WasPassiert />} />
            <Route path="/selbstschutz" element={<Selbstschutz />} />
            <Route path="/erfahrungen" element={<Erfahrungen />} />
            <Route path="/eltern" element={<Eltern />} />
            <Route path="/lehrer" element={<Lehrer />} />
            <Route path="/mobbing-dokumentieren" element={<MobbingDokumentieren />} />
            <Route path="/mobbing-protokoll" element={<MobbingProtokoll />} />
            <Route path="/cybermobbing" element={<Cybermobbing />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/betriebsrat" element={<Betriebsrat />} />
            <Route path="/anwalt" element={<Anwalt />} />
            <Route path="/mobbing-beweise" element={<MobbingBeweise />} />
            <Route path="/blog/mobbing-am-arbeitsplatz" element={<BlogArtikelArbeitsplatz />} />
            <Route path="/blog/mobbing-protokoll" element={<BlogArtikelProtokoll />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/fall/:id"
              element={
                <ProtectedRoute>
                  <CaseDetail />
                </ProtectedRoute>
              }
            />
            
            {/* Legal Pages */}
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            
            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieBanner />
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </AuthContext.Provider>
    </HelmetProvider>
  );
}

export default App;
